export const isUserAuth = (cookie: Record<string, string>) => {
  const auth = cookie['user-auth'];

  if (!auth?.length) {
    return false;
  }

  return auth.length > 0;
};

export const getCustomerId = (cookie: Record<string, string>) => cookie.customerId ?? cookie?._ym_uid;

export const getLastRegion = (cookie: Record<string, string>) => cookie._regionID;

export const getUserRegion = (cookie: Record<string, string>) => cookie._userRegion;

export const showRegionsNotification = (cookie: Record<string, string>) => !getUserRegion(cookie);

export const cookieAccepted = (cookie: Record<string, string>) => cookie.cookie_accepted === 'true';

export const getUserData = (cookie: Record<string, string>) => cookie?.userData;

export const getRMSession = (cookie: Record<string, string>): string => cookie?.rm_session;
